import React, { Component } from 'react';
import { message, Button } from 'antd';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import actions from '@/views/account/redux/action';
import LoginRender from './children/LoginRender';
import ForgotAndResetPasswordModal from '../forgotPasswordModal/ForgotAndResetPasswordModal';
import {
  requestLogin,
  requsetGetProfile,
  requsetGetSubscription,
} from '@/views/account/api/apis';
import { GALoginPageDisplay, GALoginFromError } from '@/views/account/ga/login';
import Cookies from 'js-cookie';
import '@/views/account/assets/login.scss';
import { loginWithToken } from '../../api/apis';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forgotPasswordModalVisible: false, //忘记密码弹窗控制显示变量
      loginLoading: false, //正在登陆状态
      linkToPersonalCenter: false, //是否跳转到个人中心
      linkToPurchase: false, //是否跳转到购买链接
    };
  }

  componentDidMount() {
    GALoginPageDisplay();
    let access_token = Cookies.get('access_token');
    let expire_at = Cookies.get('access_token_expires_in');
    if (access_token && expire_at) {
      let accessData = new FormData();
      accessData.append('account_token', access_token);
      accessData.append('expire_at', Math.floor(Number(expire_at) / 1000));
      loginWithToken(accessData).then((obj) => {
        if (obj.code === 200) {
          Cookies.set('authorization', obj.data.authorization, { expires: 30 });
          Cookies.set('testCookie', obj.data.authorization, {
            domain: '.afirstsoft.cn',
            expires: 30,
          });
          let hostName = window.location.hostname;
          Cookies.set('access_token', obj.data.account_access_token, {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          this.props.onAuthorizationChange(obj.data.authorization);
        }
      });
    }
  }

  /**
   * 跳转到当前个人中心
   */
  handleNavigationToPersonalCenter = () => {
    this.setState(
      {
        linkToPersonalCenter: true,
      },
      () =>
        this.setState({
          linkToPersonalCenter: false,
        })
    );
  };

  /**
   * 跳转到购买页面
   */
  handleNavigationToPurchase = () => {
    this.setState(
      {
        linkToPurchase: true,
      },
      () =>
        this.setState({
          linkToPurchase: false,
        })
    );
  };

  /**
   *控制忘记密码弹窗的出现和隐藏
   * @param {*Boolean} forgotPasswordModalVisible false即隐藏，true即显示
   */
  handleForgotPasswordModalVisible = (forgotPasswordModalVisible) => {
    this.setState({
      forgotPasswordModalVisible,
    });
  };

  /**
   *登录请求
   */
  handleRequestLogin = (value) => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    this.setState({
      loginLoading: true,
    });
    let formData = new FormData();
    formData.append('email', value.email.replace(/(^\s*)|(\s*$)/g, ''));
    formData.append('password', value.password);
    if (urlParams.has('auth')) {
      formData.append('previous_authorization', urlParams.get('auth'));
    }
    requestLogin({
      body: formData,
    })
      .then((res) => {
        if (res.code === 200) {
          message.success(this.props.t('loginSuccessTips'));
          // localStorage.setItem("authorization", res.data.authorization);
          localStorage.setItem('isSignin', 'yes');
          //将当前auth存在顶级域名cookies底下
          Cookies.set('authorization', res.data.authorization, { expires: 30 });
          Cookies.set('testCookie', res.data.authorization, {
            domain: '.afirstsoft.cn',
            expires: 30,
          });
          let hostName = window.location.hostname;
          Cookies.set('access_token', res.data.account_access_token, {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          let expires_in = new Date().getTime() + 30 * 86400 * 1000;
          Cookies.set('access_token_expires_in', expires_in.toString(), {
            expires: 30,
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          this.props.onAuthorizationChange(res.data.authorization);
          const redirect = urlParams.get('redirect');
          const to = urlParams.get('to');
          if (redirect) {
            window.location.href = redirect;
            return;
          }
          //如果需要有购买信息的话，请求订阅接口看看是否是vip
          this.handleGetSubscription(
            redirect && to === 'purchase' ? true : false
          );
          this.handleRequsetGetProfile(res.data.authorization);
          if (value.remember) {
            console.log('用户记住密码');
            Cookies.set(
              '_u_info',
              JSON.stringify({
                e: value.email.replace(/(^\s*)|(\s*$)/g, ''),
                p: value.password,
              }),
              { expires: 30 }
            );
          } else {
            console.log('用户不记住');
            if (Cookies.get('_u_info')) {
              Cookies.remove('_u_info');
            }
          }
        } else {
          GALoginFromError(res.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          loginLoading: false,
        });
      });
  };

  /**
   *请求获取用户信息
   */
  handleRequsetGetProfile = (authorization) => {
    requsetGetProfile({ headers: { authorization } })
      .then((res) => {
        if (res.code === 200) {
          this.props.onProfileObjChange(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  /**
   * 获取用户订阅信息
   * @param {Boolean} isRedirect 是否有需要订阅信息执行重定向
   */
  handleGetSubscription = (isRedirect) => {
    if (!isRedirect) {
      this.handleLoginRedirect();
    }
    requsetGetSubscription()
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          console.log('res---------------', res);
          this.props.onSubscriptionChange(res.data.subscription);
          if (res.data.subscription == null) {
            this.handleLoginRedirect(false);
          } else if (res.data.subscription.length > 0) {
            let result = res.data.subscription.filter((item) => {
              return item.product_name == 'HitPaw Online';
            });
            if (result.length == 0) {
              this.handleLoginRedirect(false);
            } else {
              if (result[0].status == 'Active') {
                this.handleLoginRedirect(true);
              } else {
                this.handleLoginRedirect(false);
              }
            }
          }
          // this.handleLoginRedirect(res.data.subscription && res.data.subscription.status === "Active" ? true : false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /**
   *控制用户登录完毕登录后的跳转链接
   * @param {Boolean} isVIP 当前用户是不是VIP（非必填）
   */
  handleLoginRedirect = (isVIP) => {
    console.log('isVIP', window.location.search);
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get('redirect');
    const to = urlParams.get('to');
    if (urlParams.has('redirect')) {
      console.log('sssssssssssdfasfasfasf', urlParams);
      if (redirect && to === 'purchase' && !isVIP) {
        console.log('购买链接');
        this.handleNavigationToPurchase();
      } else if (
        (redirect && !to) ||
        (redirect && to === 'purchase' && isVIP)
      ) {
        console.log('直接重定向到上一个链接');
        window.location.replace(redirect);
      }
    } else {
      console.log('跳转到某个链接');
      // 进入购买页，且没有登录，链接也没有带重定向的情况  对应401 linkQuery
      let href = window.location.href;
      let urlSearch =
        href.indexOf('?') !== -1 ? href.substring(href.indexOf('?')) : '';
      const urlParams = new URLSearchParams(urlSearch);
      if (urlParams.get('to') === 'purchase') {
        this.handleNavigationToPurchase();
      } else {
        this.handleNavigationToPersonalCenter();
      }
    }
  };

  render() {
    return (
      <div className='login-page overflow-hidden'>
        {this.state.linkToPersonalCenter && (
          <Navigate to='/personal-center/profile' replace='true' />
        )}
        {this.state.linkToPurchase && (
          <Navigate to={`/purchase${this.props.urlSearch}`} replace={true} />
        )}

        <LoginRender
          handleForgotPasswordModalVisible={
            this.handleForgotPasswordModalVisible
          }
          loginLoading={this.state.loginLoading}
          handleRequestLogin={this.handleRequestLogin}
          urlSearch={this.props.urlSearch}
        />

        {this.state.forgotPasswordModalVisible && (
          <ForgotAndResetPasswordModal
            visible={this.state.forgotPasswordModalVisible}
            handleVisible={this.handleForgotPasswordModalVisible}
          />
        )}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  profileObj: state.account.profileObj,
  authorization: state.account.authorization,
});
const mapDispatchToProps = (dispatch) => ({
  onProfileObjChange: (profileObj) =>
    dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: (authorization) =>
    dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['loginAndSignUp'])(Login));
